export default __webpack_public_path__ + "static/media/egranting-info.8385a291.jpeg";